<div class="popup-wrapper">
    <div class="popup-header">
        <span class="material-icons-round cyan" style="transform: rotate(90deg);">widgets</span>
        <span class="soc-panel-h">{{(editFlag ? 'MENU.EDIT_SUBCATEGORY' : "MENU.NEW_SUBCATEGORY") | translate}}</span>
    </div>
    <hr class="soc-panel-line">
    <form #f="ngForm" class="soc-form-wrapper-gap-24">
        <div class="soc-input-wrapper">
            <div class="soc-input-info-wrapper">
                <label class="soc-input-lbl w-100 text-start">{{'MENU.CATEGORY_NAME'| translate}}</label>
            </div>
            <hr class="soc-panel-line">
            <div>
                <label class="soc-display-text pt-3 pb-3 w-100 text-start">{{menuCategory.name}}</label>
                <hr class="soc-panel-line">
            </div>
        </div>
        <div class="soc-input-wrapper">
            <label for="name" class="soc-input-lbl w-100 text-start">{{'MENU.SUBCATEGORY_NAME'| translate}}</label>
            <div class="soc-error-field-wrapper">
                <span *ngIf="name.invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                <input [ngClass]="{'soc-error-active': name.invalid && f.submitted}" id="reason" required name="name" #name="ngModel" type="text" class="soc-input-field soc-input-text" placeholder="{{'TYPE_HERE' | translate}}" [(ngModel)]="menuSubcategory.name">
            </div>
        </div>

        <hr class="soc-panel-line">
        <div class="soc-wrapper-gap-12 d-flex justify-content-end">
            <button class="soc-secondary-grey-btn" type="button" (click)="close()">{{'CLOSE'| translate}}</button>
            <button class="soc-basic-cyan-btn" type="submit"
                (click)="editFlag? editSubcategory(f) : addSubcategory(f) ">{{(editFlag ?
                'SAVE_CHANGES' : 'CREATE')| translate}}</button>
        </div>
    </form>
</div>